export default "__VITE_PUBLIC_ASSET__f27402e4__"